export function splitRelationOrdersSpace (str) {
  return str.split(' ')
    .map(item => item.trim())
    .filter(item => !!item)
}
